import React from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { TextBlock } from "../../../widget/common/ui/Text";
import AppTheme from "../../../service/app_config/AppTheme";
import { IconNormal } from "../../../widget/common/ui/Icon";
import { GroupChatInfoContextImport } from "../../../provider/chats/chats/group_chat_info/GroupChatInfoContextProvider";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { textCase } from "../../../service/ui/UI";
import { LogoRound } from "../../../widget/common/ui/Logo";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import Div from "../../../widget/common/ui/Div";

const GroupChatInfoContent: React.FC<{ viewType: "sidebar" | "modal" }> = ({
  viewType,
}) => {
  const type: number = ResponsiveDeviceType();

  const {
    chatSelected,
    groupInfo,
    groupDetail,
    handleClickMember,
    handleNavigateMedia,
  } = GroupChatInfoContextImport();

  return (
    <>
      {chatSelected == null && groupInfo != null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <div className={`${viewType === "sidebar" ? "pt-3" : ""}`}>
          <div
            className={`p-4 ${
              viewType === "modal" ? "bgcolor-primary pt-3 pb-4" : ""
            }`}
          >
            <div className="text-center">
              <Center>
                <LogoRound
                  url={chatSelected?.logo!}
                  isProfile={true}
                  name={chatSelected?.name!}
                  size={type === 3 ? 100 : 120}
                />
              </Center>
              <SpacingHeight value={20} />
              <TextBlock
                fontName="bold"
                fontSize="20_21"
                textColor={viewType === "modal" ? "theme-font" : "theme-label"}
                maxLine={1}
              >
                {textCase(chatSelected?.name!)}
              </TextBlock>
              <TextBlock
                fontName="bold"
                fontSize="16_17"
                textColor={viewType === "modal" ? "theme-font" : "theme-label"}
                maxLine={1}
                className="pt-1"
              >
                {groupInfo?.members_count} {AppTranslation.text("members")}
              </TextBlock>
            </div>
          </div>

          <div className="px-4">
            {viewType === "modal" && (
              <div
                className="d-flex align-items-center justify-content-between py-2"
                role="button"
                onClick={handleNavigateMedia}
              >
                <TextBlock
                  fontName="bold"
                  fontSize="16_17"
                  textColor="theme-label"
                  maxLine={1}
                  className="pt-1"
                >
                  {AppTranslation.text("group_media")}
                </TextBlock>

                <IconNormal
                  name="arrow_right"
                  size={17}
                  color={AppTheme.label}
                />
              </div>
            )}
            <SpacingHeight value={20} />

            {groupDetail == null ? (
              <Center className="pt-5">{Loader.normal()}</Center>
            ) : (
              <div>
                <TextBlock
                  fontName="bold"
                  fontSize="16_17"
                  textColor="theme-label"
                  maxLine={1}
                >
                  {AppTranslation.text("members")}
                </TextBlock>

                <Listing>
                  {(groupDetail.members ?? []).map((member, key) => (
                    <ListItem key={key}>
                      <div
                        role="button"
                        className="d-flex align-items-center justify-content-between w-100"
                        onClick={() => handleClickMember(member)}
                      >
                        <Div className="d-flex align-items-center">
                          <Div>
                            <LogoRound
                              url={member?.logo_url!}
                              isProfile={true}
                              name={member?.name!}
                              size={type === 1 ? 40 : type === 2 ? 55 : 60}
                            />
                          </Div>
                          <Div className="ps-3 w-100">
                            <TextBlock
                              fontName="bold"
                              fontSize="13_14"
                              textColor="black"
                              maxLine={1}
                            >
                              {textCase(member?.name!)}
                            </TextBlock>
                            <TextBlock
                              fontName="book"
                              fontSize="12_14"
                              textColor="black"
                              maxLine={1}
                            >
                              {textCase(member?.title!)}
                            </TextBlock>
                            <TextBlock
                              fontName="book"
                              fontSize="12_14"
                              textColor="black"
                              maxLine={1}
                            >
                              {textCase(member?.branch_name!)}
                            </TextBlock>
                          </Div>
                        </Div>
                        {member.role === "1" && (
                          <Div>
                            <div className="theme-badge-normal bgcolor-primary color-theme-font font-size-10_12 font-gotham-medium">
                              {AppTranslation.text("admin")}
                            </div>
                          </Div>
                        )}
                      </div>
                    </ListItem>
                  ))}
                </Listing>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default GroupChatInfoContent;
